<template>
  <div class="row mx-0 px-3 py-4 border-top">
    <div class="input-group row pe-0">
      <div
        class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
      >
        <label class="size-12" for="">現在（前職）の年収</label>
        <span class="tag-thirdly size-10 ms-2">必須</span>
      </div>
      <div class="row p-0">
        <div class="col-12 col-md-4 pe-0">
          <Field v-slot="{ field, errors }" v-model="workHistoryStore.income_id" name="income_id">
            <select
              class="form-select select-input-primary size-14 p-0d8"
              :class="{ 'is-invalid': !!errors.length }"
              aria-label="master-icome-label"
              v-bind="field"
            >
              <option value="" disabled selected>選択してください</option>
              <option v-for="income in incomes" :key="income.id" :value="income.id">
                {{ income.display_amount }}
              </option>
            </select>
            <ErrorMessage name="income_id" class="invalid-feedback" />
          </Field>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Field, ErrorMessage } from 'vee-validate';
import { onMounted, ref } from 'vue';
import { useWorkHistoryStore } from '@/stores/resume-candidate/WorkHistory.store';
import { IncomePrimary } from '@/types/models/income';
import { getIncomes } from '@/apis/candidate';

const workHistoryStore = useWorkHistoryStore();
const incomes = ref<IncomePrimary[]>([]);

onMounted(() => {
  getIncomesData();
});

const getIncomesData = async (): Promise<void> => {
  const response = await getIncomes();
  if (response.status === 200) {
    incomes.value = response.data;
  }
};
</script>
